import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignMessRequestsService } from 'services/signMessRequests/sign-mess-requests.service';
import { SignMessRequests } from 'domain-models/SignMessRequests';
import { Helper } from 'libraries/Helper';

@Component({
	selector: 'sign-mess-requests-cmp',
	moduleId: module.id,
	templateUrl: './sign-mess-requests.component.html',
	styleUrls: ['./sign-mess-requests.component.css']
})
export class SignMessRequestsComponent implements OnInit {
	public requests: SignMessRequests[];
	loading: Boolean = false;
	yearFilter: string;
	requestTypeList = [{ label: 'All', value: '' }];
	signList = [{ label: 'All', value: '' }];
	usernameList = [{ label: 'All', value: '' }];
	/**
	 *
	 */
	constructor(private signMessRequestsService: SignMessRequestsService) {}
	ngOnInit() {
		this.loading = true;

		this.signMessRequestsService.getAll().subscribe((data) => {
			this.requests = data;
			this.requests.forEach((request) => {
				request.Timestamp = Helper.FormateDate(new Date(request.Timestamp));
				request.Id = +request.Id;
			});

			this.populateFilters();
			this.loading = false;
		});

		// this.tableData2 = {
		//     headerRow: [ 'ID', 'Name',  'Salary', 'Country', 'City' ],
		//     dataRows: [
		//         ['1', 'Dakota Rice','$36,738', 'Niger', 'Oud-Turnhout' ],
		//         ['2', 'Minerva Hooper', '$23,789', 'Curaçao', 'Sinaai-Waas'],
		//         ['3', 'Sage Rodriguez', '$56,142', 'Netherlands', 'Baileux' ],
		//         ['4', 'Philip Chaney', '$38,735', 'Korea, South', 'Overland Park' ],
		//         ['5', 'Doris Greene', '$63,542', 'Malawi', 'Feldkirchen in Kärnten', ],
		//         ['6', 'Mason Porter', '$78,615', 'Chile', 'Gloucester' ]
		//     ]
		// };
	}

	populateFilters() {
		const requestTypes = Array.from(new Set(this.requests.map((r) => r.RequestType)));
		const signs = Array.from(new Set(this.requests.map((r) => r.Location)));
		const usernames = Array.from(new Set(this.requests.map((r) => r.ControllerUserName)));

		requestTypes.forEach((r) => {
			let label = r;
			let value = r;
			this.requestTypeList.push({ label, value });
		});

		signs.forEach((s) => {
			let label = s;
			let value = s;
			this.signList.push({ label, value });
		});

		usernames.forEach((u) => {
			let label = u;
			let value = u;
			this.usernameList.push({ label, value });
		});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/requests/sign-mess-requests.component.ts